import { useLocation } from "react-router";

import { AuthorizeHandsoffQueryParams, AuthorizeQueryParams } from "@/models/site-credentials/common/AuthorizeQueryParams";

export const useAuthorizeQueryParams = (): AuthorizeQueryParams => {
  const urlSearchParams = new URLSearchParams(useLocation().search);

  return {
    clientId: urlSearchParams.get("clientId"),
    token: urlSearchParams.get("token"),
    deeplinkAction: urlSearchParams.get("deeplinkAction")
  };
};


export const useAuthorizeHandsoffQueryParams = (): AuthorizeHandsoffQueryParams => {
  const urlSearchParams = new URLSearchParams(useLocation().search);

  return {
    language: urlSearchParams.get("language"),
  };
};
